//MERK! HVIS MAN FINNER EN FEIL I UTREGNINGEN HER, SÅ ER DET OVERHENGENDE FARE FOR AT SAMME FEIL FINNES I UTREGNING.TS UNDER HELGRAD UTLAND VEILEDER. 
//ÅRSAKEN ER AT UTREGNINGENE ER SVÆRT LIKE. 

import StipendLandModel from '../Models/StipendLandModel';
import {SatserUtlandModel} from '../Models/SatserUtlandModel';
import * as ValgTypes from '../Store/Valg/Types';
import VerdensdelValg from '../Utilities/VerdensdelValg';
import VarighetValg from './VarighetValg';
import {harValgtLandSomGirRekrutteringsstipendUtveksling} from './LandMedRekrutteringsstipendUtveksling';

export function formatNumber(tall: number, locale: string = 'nb-NO') : string {
    let tallSomString: string = tall.toString();
    if(locale === 'en-US') {
        tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ',');
    } else {
        tallSomString = tallSomString.replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ' ');
    }
    
    return tallSomString;
}

export function harValgtGodkjentUniversitetSomGirUtvidetStipend(valg: ValgTypes.ValgState): boolean {
    if (valg.eUniversitet !== undefined && valg.eUniversitet.id !== undefined && valg.eUniversitet.id !== "" && valg.eUniversitet.id !== "Nei") {
        //console.log("godkjent for tilleggstipend");
        return true;
    }

    //console.log("ikke godkjent for tilleggstipend");
    return false;
}



export function regnUtBasisLan(valg: ValgTypes.ValgState, stamData: SatserUtlandModel | null) : StipendLandModel {

    let basisLan: StipendLandModel = {
        stipendKroner:0,
        stipendProsent:0,
        lanKroner:0,
        lanProsent:0,
        totaltStipendOgLan:0
    };

    if(stamData == null) return basisLan;

    let antallDagerMedStotte: number = 0;

    if(valg.aVarighet?.value === VarighetValg.valgHel) {
        antallDagerMedStotte = 330;
    } else if(valg.aVarighet?.value === VarighetValg.valgHost) {
        antallDagerMedStotte = 150;
    } else if(valg.aVarighet?.value === VarighetValg.valgVaar) {
        antallDagerMedStotte = 180;
    } 

    let basis: number = stamData.SATS_ST01_MAKS_BASISSTOTTE_DAG * antallDagerMedStotte;
    
    basisLan.lanProsent = 60;
    basisLan.stipendProsent = 40;

    basisLan.totaltStipendOgLan = Math.round(basis);

    basisLan.stipendKroner = Math.round(basisLan.totaltStipendOgLan * (basisLan.stipendProsent / 100));
    basisLan.lanKroner = Math.round((basisLan.totaltStipendOgLan * (basisLan.lanProsent / 100)) - 0.1);

    return basisLan;
}

export function regnUtReiseStotte(valg: ValgTypes.ValgState, stamData: SatserUtlandModel | null): StipendLandModel {

    let reiseStotte: StipendLandModel = {
        stipendKroner: 0,
        stipendProsent: 0,
        lanKroner: 0,
        lanProsent: 0,
        totaltStipendOgLan: 0
    };

    let antallReiser: number = 4;

    if(valg.aVarighet?.value !== VarighetValg.valgHel) {
        antallReiser = 2;
        reiseStotte.lanProsent = 65;
        reiseStotte.stipendProsent = 35;
    } else {
        reiseStotte.lanProsent = 82.5;
        reiseStotte.stipendProsent = 17.5;
    }

    if(stamData == null) return reiseStotte;

    if (valg.bVerdensdel?.value === VerdensdelValg.b1_afrika) {
        reiseStotte.totaltStipendOgLan = Math.round(stamData.SATS_ST01_REISETILSKUDD_AFRIKA * antallReiser);
    }

    if (valg.bVerdensdel?.value === VerdensdelValg.b2_asia) {
        reiseStotte.totaltStipendOgLan = Math.round(stamData.SATS_ST01_REISETILSKUDD_ASIA * antallReiser);
    }

    if (valg.bVerdensdel?.value === VerdensdelValg.b3_europa) {
        reiseStotte.totaltStipendOgLan = Math.round(stamData.SATS_ST01_REISETILSKUDD_EUROPA * antallReiser);
    }

    if (valg.bVerdensdel?.value === VerdensdelValg.b4_nordMellomAmerika) {
        reiseStotte.totaltStipendOgLan = Math.round(stamData.SATS_ST01_REISETILSKUDD_NORD_OG_MELLOM_AMERIKA * antallReiser);
    }

    if (valg.bVerdensdel?.value === VerdensdelValg.b5_oseania) {
        reiseStotte.totaltStipendOgLan = Math.round(stamData.SATS_ST01_REISETILSKUDD_OSEANIA * antallReiser);
    }

    if (valg.bVerdensdel?.value === VerdensdelValg.b6_sorAmerika) {
        reiseStotte.totaltStipendOgLan = Math.round(stamData.SATS_ST01_REISETILSKUDD_SOR_AMERIKA * antallReiser);
    }

    reiseStotte.stipendKroner = Math.round(reiseStotte.totaltStipendOgLan * (reiseStotte.stipendProsent / 100));
    reiseStotte.lanKroner = Math.round((reiseStotte.totaltStipendOgLan * (reiseStotte.lanProsent / 100)) - 0.1);

    return reiseStotte;
}

export function regnUtSkolepengeUtvidetStipend(valg: ValgTypes.ValgState, stamData:SatserUtlandModel | null): number {

    if(!harValgtGodkjentUniversitetSomGirUtvidetStipend(valg)) return 0; 

    if(valg.dSkolepenger === null || valg.dSkolepenger === undefined) return 0;

    if(stamData === null || stamData === undefined) return 0;

    let skoleKostnad: number = parseInt(valg.dSkolepenger.value.replace(/\s/g, ''));

    if (skoleKostnad <= 0) return 0;

    let utvidetStipend: number = 0;

    let nevner: number = 1;
    if(valg.aVarighet?.value === VarighetValg.valgHost || valg.aVarighet?.value === VarighetValg.valgVaar) {
        nevner = 2;
    }

    if (skoleKostnad > stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner
        && skoleKostnad < (stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR + stamData.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR) / nevner)
    {
        utvidetStipend = skoleKostnad - (stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner);
    }

    if (skoleKostnad > (stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR + stamData.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR) / nevner)
    {
        utvidetStipend = stamData.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR / nevner;
    }

    return Math.round(utvidetStipend);
}

export function regnUtSkolepengerStotte(valg: ValgTypes.ValgState, stamData: SatserUtlandModel | null): StipendLandModel {

    let skolepengeStotte: StipendLandModel = {
        stipendKroner: 0,
        stipendProsent: 0,
        lanKroner: 0,
        lanProsent: 0,
        totaltStipendOgLan: 0
    };

    //vi setter riktig prosentsats for stipend og lån er lik uansett hvilken type grad. Dette skiller seg fra helgrad utland. 
    skolepengeStotte.stipendProsent = 40;
    skolepengeStotte.lanProsent = 60;

    if (valg.dSkolepenger === undefined) return skolepengeStotte;

    if(stamData == null) return skolepengeStotte;

    let skoleKostnad: number = parseInt(valg.dSkolepenger.value.replace(/\s/g, ''));

    //man får ingen skolepenge-støtte dersom det ikke skal betales skolepenger.
    if (skoleKostnad <= 0) {
        return skolepengeStotte;
    }

    let nevner: number = 1;
    if(valg.aVarighet?.value === VarighetValg.valgHost || valg.aVarighet?.value === VarighetValg.valgVaar) {
        nevner = 2;
    }

    //maks sum av ID6 som man deler mellom stipend og lån. restverdien av ID6 er alltid lån. 
    let ID77 = stamData.SATS_ST01_SKOLEPENGEGRUNNLAG_STIPEND_MAKS_PER_AAR / nevner;

    //restverdien av ID6 er alltid lån.
    let ID6_rest_etter_ID77 = (stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner) - (stamData.SATS_ST01_SKOLEPENGEGRUNNLAG_STIPEND_MAKS_PER_AAR / nevner);

    //MERK AT ALLE UTREGNINGENE NEDENFOR TAR HENSYN TIL OM DET ER HEL ÅR ELLER ETT SEMESTER. 
    //DET GJØRES VED AT MAN DELER PÅ NEVNER SOM ENTEN BLIR SATT TIL 1 ELLER 2 BASERT PÅ OM DET ER HELT ÅR ELLER IKKE.

    if (valg.dSkolepenger.tillegg){
        //skolepengeStøtte relatert til studenter fra BI

        skolepengeStotte.stipendProsent = 0;
        skolepengeStotte.lanProsent = 100;

        if(skoleKostnad === 0) {
            skolepengeStotte.stipendKroner = 0;
            skolepengeStotte.lanKroner = 0;
        } else if (skoleKostnad < (stamData.SATS_ST01_SKOLEPENGESTOTTE_MAKS_PER_AR_NORDEN / nevner)) {
            skolepengeStotte.stipendKroner = 0;
            skolepengeStotte.lanKroner = skoleKostnad;
        } else if (skoleKostnad > (stamData.SATS_ST01_SKOLEPENGESTOTTE_MAKS_PER_AR_NORDEN / nevner)){ 
            skolepengeStotte.stipendKroner = 0;
            skolepengeStotte.lanKroner = stamData.SATS_ST01_SKOLEPENGESTOTTE_MAKS_PER_AR_NORDEN / nevner;
        }
    }
    else if (skoleKostnad > stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner
        && skoleKostnad < ((stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR + stamData.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR) / nevner)
        && harValgtGodkjentUniversitetSomGirUtvidetStipend(valg)) {
        //har rett på tilleggsstipend (ID10)
        //får differansen mellom ID6 og D1 som tilleggsstipend

        //vi regner ut andel stipend og lån av ID77 siden det er kun den summen av ID6 man kan få omgjort til stipend.
        let ID6_stipend: number = ID77 * (skolepengeStotte.stipendProsent / 100);
        let ID6_lan: number = ID77 * (skolepengeStotte.lanProsent / 100);
        let tillegsstipend: number = skoleKostnad - (stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner);

        skolepengeStotte.stipendKroner = Math.round(ID6_stipend + tillegsstipend);
        skolepengeStotte.lanKroner = Math.round(ID6_lan + ID6_rest_etter_ID77 - 0.1);

        //console.log("Utregning 1");

    } else if (skoleKostnad > ((stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR + stamData.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR) / nevner)
        && harValgtGodkjentUniversitetSomGirUtvidetStipend(valg)) {
        //har rett på tilleggsstipend (ID10) og tilleggslån (ID9)
        //Tilleggsstipend er ID10  
        //Tilleggslånet er D1 minus maks støtte og lån (ID6 og ID10), men lånet er maks opptil ID9.

        // ***VI REGNER FØRST UT STIPEND***
        let ID6_stipend: number = ID77 * (skolepengeStotte.stipendProsent / 100);
        let tillegsstipend: number = stamData.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR / nevner;
        let tot_stipend: number = ID6_stipend + tillegsstipend;

        // ***VI REGNER UT LÅN***
        let ID6_lan: number = ID77 * (skolepengeStotte.lanProsent / 100) + ID6_rest_etter_ID77;
        let tilleggs_lan: number = skoleKostnad - (stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner) - (stamData.SATS_ST01_TILLEGGSTIPEND_MAKS_PER_AAR / nevner);

        //lån er maks opptil ID9. 
        if (tilleggs_lan > stamData.SATS_ST01_TILLEGGSLAAN_MAKS_PER_AAR / nevner) {
            tilleggs_lan = stamData.SATS_ST01_TILLEGGSLAAN_MAKS_PER_AAR / nevner;
        }

        let tot_lan: number = ID6_lan + tilleggs_lan;

        skolepengeStotte.lanKroner = Math.round(tot_lan - 0.1);
        skolepengeStotte.stipendKroner = Math.round(tot_stipend);

        //console.log("Utregning 2");
    } else if (skoleKostnad > stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner
        && skoleKostnad <= ((stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR + stamData.SATS_ST01_TILLEGGSLAAN_MAKS_PER_AAR) / nevner)
        && !harValgtGodkjentUniversitetSomGirUtvidetStipend(valg)) {
        //har rett på skolepengestøtte og tilleggslån
        //tilleggslånet er differansen mellom ID6 og skoleKostnad. 

        let ID6_stipend = ID77 * (skolepengeStotte.stipendProsent / 100);
        let ID6_lan: number = ID77 * (skolepengeStotte.lanProsent / 100);
        let tileggsLan: number = skoleKostnad - (stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner);

        skolepengeStotte.stipendKroner = Math.round(ID6_stipend);
        skolepengeStotte.lanKroner = Math.round(ID6_lan + tileggsLan + ID6_rest_etter_ID77 - 0.1);

        //console.log("Utregning 3");
    } else if (skoleKostnad > ((stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR + stamData.SATS_ST01_TILLEGGSLAAN_MAKS_PER_AAR) / nevner)
        && !harValgtGodkjentUniversitetSomGirUtvidetStipend(valg)) {
        //har rett på skolepengestøtte og tilleggslån
        //får ID9 som tilleggslån
        let ID6_stipend: number = ID77 * (skolepengeStotte.stipendProsent / 100);
        let ID6_lan: number = ID77 * (skolepengeStotte.lanProsent / 100);

        skolepengeStotte.stipendKroner = Math.round(ID6_stipend);
        skolepengeStotte.lanKroner = Math.round(ID6_lan + (stamData.SATS_ST01_TILLEGGSLAAN_MAKS_PER_AAR / nevner) + ID6_rest_etter_ID77 - 0.1);

        //console.log("Utregning 4");
    } else if (skoleKostnad < stamData.SATS_ST01_SKOLEPENGESTOTTE_UTENFOR_NORDEN_MAKS_PER_AAR / nevner) {
        //hvis D1 er mindre enn ID6 så får man kun D1 i støtte. Man får ikke ID9 eller ID10. 
        //hva som er lån og hva som er stipend følger vanlige regler basert på type studie. 

        //console.log("Utregning 5 - skolekostnad er mindre enn ID6");

        if (skoleKostnad <= ID77) {
            let ID6_stipend: number = skoleKostnad * (skolepengeStotte.stipendProsent / 100);
            let ID6_lan: number = skoleKostnad * (skolepengeStotte.lanProsent / 100);

            skolepengeStotte.stipendKroner = Math.round(ID6_stipend);
            skolepengeStotte.lanKroner = Math.round(ID6_lan - 0.1);

            //console.log("Utregning 5a - skolekostnad er mindre enn ID77");
        } else {
            let ID6_stipend: number = ID77 * (skolepengeStotte.stipendProsent / 100);
            let ID6_lan: number = ID77 * (skolepengeStotte.lanProsent / 100);
            let ID6_rest_lan: number = skoleKostnad - ID77;

            skolepengeStotte.stipendKroner = Math.round(ID6_stipend);
            skolepengeStotte.lanKroner = Math.round(ID6_lan + ID6_rest_lan - 0.1);

            //console.log("Utregning 5b - skolekostnad er større enn ID77");
        }
    }

    //deler resultatet på 2(nevner) dersom det er snakk om ett semester. 
    skolepengeStotte.lanKroner = Math.round(skolepengeStotte.lanKroner - 0.1); 
    skolepengeStotte.stipendKroner = Math.round(skolepengeStotte.stipendKroner); 
    
    skolepengeStotte.totaltStipendOgLan = Math.round(skolepengeStotte.lanKroner + skolepengeStotte.stipendKroner);    

    return skolepengeStotte;
}

export function regnUtRekrutteringsstipendUtveksling(valg: ValgTypes.ValgState, stamData:SatserUtlandModel | null): number {
    
    if(!harValgtLandSomGirRekrutteringsstipendUtveksling(valg)) return 0; 
    
    if(stamData === null || stamData === undefined) return 0;
 
    let rekrutteringsstipend: number = 0;
    let antallDagerMedStotte: number = 0;

    if(valg.aVarighet?.value === VarighetValg.valgHel) {
        antallDagerMedStotte = 300;
    } else if(valg.aVarighet?.value === VarighetValg.valgHost) {
        antallDagerMedStotte = 150;
    } else if(valg.aVarighet?.value === VarighetValg.valgVaar) {
        antallDagerMedStotte = 150;
    } 

    rekrutteringsstipend = stamData.SATS_ST01_STIPENDTILUTVEKSLING_DAGSATS * antallDagerMedStotte;
    
    return Math.round(rekrutteringsstipend);
}
